import { useEffect } from 'react';
import amplitude from '../services/amplitude';
import { PaymentMethodType } from '@autopass-web/types';

export const useAmplitedeAuthPageview = (
  {
    paymentType,
    ticketId,
    plateNumber,
  }: {
    ticketId: string;
    plateNumber: string;
    paymentType: PaymentMethodType;
  },
  isInit: boolean,
) => {
  useEffect(() => {
    if (isInit === false) return;
    if (paymentType == null || ticketId == null || plateNumber == null) return;
    amplitude.authPageView({ paymentType, ticketId, plateNumber });
  }, [isInit, paymentType, ticketId, plateNumber]);
};
